import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Form.css";

/*
  UpdateProfile 组件允许当前登录用户更新其个人资料（邮箱和密码）。
  用户可以选择更新邮箱、密码，或两者同时更新。
  如果密码和确认密码不匹配，将显示错误提示信息。
*/
const UpdateProfile = () => {
  // 使用 useRef 获取表单输入的引用，以便读取用户输入的值
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();

  // 从认证上下文中获取当前用户以及更新邮箱和密码的方法
  const { currentUser, updateEmail, updatePassword } = useAuth();

        // 当前登陆的用户：currentUser，可用作判断用户是否登陆。要求其注册登陆

  // 定义状态变量：
  // error 用于存储错误消息，
  // loading 用于标记操作是否正在进行
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // 使用 useNavigate 实现页面跳转
  const navigate = useNavigate();

  // 处理表单提交事件：更新用户资料
  const handleSubmit = (e) => {
    e.preventDefault(); // 阻止默认表单提交行为

    // 检查密码和确认密码是否匹配
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match");
    }

    // 初始化一个数组来存储所有的更新操作（返回 Promise）
    const promises = [];
    setLoading(true);  // 开启加载状态
    setError("");      // 清空之前的错误信息

    // 如果用户输入的邮箱与当前用户邮箱不一致，则添加更新邮箱操作
    if (emailRef.current.value !== currentUser.email) {
      promises.push(updateEmail(emailRef.current.value));
    }
    // 如果用户输入了新的密码，则添加更新密码操作
    if (passwordRef.current.value) {
      promises.push(updatePassword(passwordRef.current.value));
    }

    // 执行所有更新操作
    Promise.all(promises)
      .then(() => {
        // 如果所有操作成功，则导航到首页
        navigate("/");
      })
      .catch(() => {
        // 如果其中任何一个操作失败，显示错误提示
        setError("Failed to update account");
      })
      .finally(() => {
        // 无论成功还是失败，都关闭加载状态
        setLoading(false);
      });
  };

  return (
    <div className="form-container">
      {/* 使用 Card 组件包装更新资料表单 */}
      <Card>
        <Card.Body>
          <h2 className="text-center mb-4">Update Profile</h2>
                      {/* {currentUser && currentUser.email} */}
            {/* 在页面上显示当前登陆的用户 */}
          {/* 可选：显示当前用户的邮箱信息（此处被注释掉） */}
          {/* {currentUser && currentUser.email} */}
          {/* 如果存在错误，则使用 Alert 组件显示错误信息 */}
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            {/* 邮箱输入字段 */}
            <Form.Group id="email" className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                ref={emailRef}
                required
                defaultValue={currentUser.email}
              />
            </Form.Group>
            {/* 密码输入字段（留空表示不更改密码） */}
            <Form.Group id="password" className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                ref={passwordRef}
                placeholder="Leave blank to keep the same"
              />
            </Form.Group>
            {/* 密码确认输入字段 */}
            <Form.Group id="password-confirm" className="mb-3">
              <Form.Label>Password Confirmation</Form.Label>
              <Form.Control
                type="password"
                ref={passwordConfirmRef}
                placeholder="Leave blank to keep the same"
              />
            </Form.Group>
            {/* 提交按钮：当加载状态为 true 时禁用按钮 */}
            <Button disabled={loading} className="w-100" type="submit">
              Update
            </Button>
          </Form>
        </Card.Body>
      </Card>
      {/* 底部链接：点击可返回主页 */}
      <div className="w-100 text-center mt-2">
        <Link to="/">Cancel</Link>
      </div>
    </div>
  );
};

export default UpdateProfile;